// Global configuration constants
// Production values for deployment to barista.theautochef.com (no .env on server)
// In production builds (yarn build), ALWAYS use PRODUCTION - env vars are ignored.
// In development (yarn start), .env can override for local testing.

const IS_PRODUCTION = process.env.NODE_ENV === "production";

// --- Production config (always used when NODE_ENV=production) ---
const PRODUCTION = {
  API_URL: "https://backend-barrista.theautochef.com",
  SOCKET_URL: "https://backend-barrista.theautochef.com",
  API_BASE_PATH: "/graphql",
  PAYMENT_GATEWAY: "razorpay",
  CURRENCY: "INR",
  RAZORPAY_KEY_ID: "rzp_test_fokLH6VFkw4G4V",
  PAYMOB_IFRAME_ID: "12445",
  VENUE_ID: 1,
  SINGLE_ORDER: true,
};

export const MAX_CART_ITEMS = 3;
export const SINGLE_ORDER =
  process.env.REACT_APP_SINGLE_ORDER !== undefined
    ? process.env.REACT_APP_SINGLE_ORDER.toLowerCase() === "true"
    : PRODUCTION.SINGLE_ORDER;

// Helpers to sanitize URLs (remove inline comments, trailing /graphql, trailing slashes)
const sanitizeUrl = (raw, fallback) => {
  const base = (raw || fallback).split("#")[0].trim();
  return base.replace(/\/graphql\/?$/, "").replace(/\/$/, "") || fallback;
};

// If mistakenly pointed to orchestrator (4500) or old backend port (4000), use 4001
const fixBackendPort = (url) =>
  url.replace(/:4500(?!\d)/g, ":4001").replace(/:4000(?!\d)/g, ":4001");

// API Configuration: production build ALWAYS uses PRODUCTION (no localhost in deployed bundle)
const apiCandidate = IS_PRODUCTION
  ? PRODUCTION.API_URL
  : sanitizeUrl(process.env.REACT_APP_API_URL, PRODUCTION.API_URL);
export const API_URL = fixBackendPort(apiCandidate);

// Base path for REST API - /graphql for LiteSpeed proxy (production)
const API_BASE_PATH = (
  IS_PRODUCTION
    ? PRODUCTION.API_BASE_PATH
    : process.env.REACT_APP_API_BASE_PATH !== undefined
      ? process.env.REACT_APP_API_BASE_PATH
      : PRODUCTION.API_BASE_PATH
).replace(/\/$/, "");
export const API_BASE_URL = API_BASE_PATH
  ? `${API_URL}${API_BASE_PATH}`
  : API_URL;
// Socket.IO path (must match backend SOCKET_PATH when using /graphql proxy)
export const SOCKET_PATH = API_BASE_PATH
  ? `${API_BASE_PATH}/socket.io`
  : "/socket.io";

// Socket.io: production build ALWAYS uses PRODUCTION (no localhost in deployed bundle)
const socketCandidate = IS_PRODUCTION
  ? PRODUCTION.SOCKET_URL
  : sanitizeUrl(
      process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL,
      API_URL,
    );
export const SOCKET_URL = fixBackendPort(socketCandidate);

export const VENUE_ID =
  process.env.REACT_APP_VENUE_ID !== undefined
    ? parseInt(process.env.REACT_APP_VENUE_ID, 10) || PRODUCTION.VENUE_ID
    : PRODUCTION.VENUE_ID;

// Payment config - production values in constants (no .env needed on server)
export const PAYMENT_GATEWAY =
  process.env.REACT_APP_PAYMENT_GATEWAY || PRODUCTION.PAYMENT_GATEWAY;
export const CURRENCY = process.env.REACT_APP_CURRENCY || PRODUCTION.CURRENCY;
export const RAZORPAY_KEY_ID =
  process.env.REACT_APP_RAZORPAY_KEY_ID || PRODUCTION.RAZORPAY_KEY_ID;
export const PAYMOB_IFRAME_ID =
  process.env.REACT_APP_PAYMOB_IFRAME_ID || PRODUCTION.PAYMOB_IFRAME_ID;

// Debug: log URLs on load (dev only) - helps diagnose ERR_CONNECTION_REFUSED
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  console.log(
    "[Customer Kiosk] API_URL:",
    API_URL,
    "| SOCKET_URL:",
    SOCKET_URL,
  );
}

// Customer token: links orders to this device/session (multi-user QR scenario)
const CUSTOMER_TOKEN_KEY = "barrista_customer_token";
export const getOrCreateCustomerToken = () => {
  let token = sessionStorage.getItem(CUSTOMER_TOKEN_KEY);
  if (!token) {
    token =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "cust_" +
          Date.now().toString(36) +
          "_" +
          Math.random().toString(36).slice(2, 11);
    sessionStorage.setItem(CUSTOMER_TOKEN_KEY, token);
  }
  return token;
};
